import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CountryRoutingModule } from "./country-routing.module";
import { CountryListComponent } from "./country-list/country-list.component";
import { CountryCreateComponent } from "./country-create/country-create.component";

import { ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2SmartTableModule } from "ng2-smart-table";

@NgModule({
  declarations: [CountryListComponent, CountryCreateComponent],
  imports: [
    CommonModule,
    CountryRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule,
  ],
})
export class CountryModule {}
